<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <router-link v-if="item" :to="{ name: 'EXSBWarehouseList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <Loader v-if="isLoading"></Loader>
      <b-row v-else-if="!isLoading && item">
        <b-col>
          <b-card>
            <h6 class="card-title">{{$t('views.exsbwarehouses.show.title')}} {{ item && item['title'] }}</h6>
            <hr class="mb-1 mt-1">
            <p v-if="item.name"><b>{{$t('views.exsbwarehouses.show.name')}}:</b> {{ item['name'] }}</p>
            <p v-if="item.type"><b>{{$t('views.exsbwarehouses.show.type')}}:</b> {{ item['type'].name }}</p>
            <p v-if="item.idCustom"><b>{{$t('views.exsbwarehouses.show.idCustom')}}:</b> {{ item['idCustom'] }}</p>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="!isLoading && item">
        <b-col>
          <b-card>
            <h6 class="card-title">{{$t('views.exsbwarehouses.show.itemsStates')}} {{ item && item['title'] }}</h6>
            <hr class="mb-1 mt-1">
              <table class="border-table">
                <tr>
                  <th></th>
                  <th>
                    {{$t('views.exsbwarehouses.show.itemsStatesTable.item')}}
                  </th>
                  <th>
                    {{$t('views.exsbwarehouses.show.itemsStatesTable.quantity')}}
                  </th>
                </tr>
                <tr v-for="(itemsState, index) in itemsStates" v-bind:key="'itemsState-' + index">
                  <td class="text-center">
                    <i v-if="itemsState.item.minimumAvailability && itemsState.quantity <= itemsState.item.minimumAvailability" class="fa fa-circle fa-lg"
                       style="color: #dc3545;"
                       v-b-tooltip :title="$t('views.exsbitems.form.minimumAvailability') + ': ' + itemsState.item.minimumAvailability"></i>
                    <i v-else-if="itemsState.item.warningAvailability && itemsState.quantity <= itemsState.item.warningAvailability" class="fa fa-circle fa-lg"
                       style="color: #ffc107;"
                       v-b-tooltip :title="$t('views.exsbitems.form.warningAvailability') + ': ' + itemsState.item.warningAvailability"></i>
                  </td>
                  <td>
                    <router-link v-if="itemsState.item['@id']" :to="{ name: 'EXSBItemShow', params: { id: itemsState.item['@id'] }}">{{ itemsState.item.name }}</router-link>
                  </td>
                  <td>{{ itemsState.quantity }}</td>
                </tr>
              </table>
          </b-card>
        </b-col>
        <b-col>
          <b-card>
            <h6 class="card-title">{{$t('views.exsbwarehouses.show.documents')}} {{ item && item['title'] }}</h6>
            <hr class="mt-1 mb-0">
            <b-row>
              <b-col>
                <table class="table table-sm border-table">
                  <tr>
                    <th>{{$t('views.exsbdocument.list.documentType')}}</th>
                    <th>{{$t('views.excmtask.list.table.task')}}</th>
                    <th>{{$t('views.exsbinvoices.show.title')}}</th>
                    <th>{{$t('views.exsbdocument.list.number')}}</th>
                    <th>{{$t('views.exsbdocument.list.dateOfIssue')}}</th>
                    <th></th>
                  </tr>
                  <tr
                    v-for="item in documents" :key="item['@id']">
                    <td>{{ item['documentType'].name }}</td>
                    <td v-if="item.task">
                      <router-link
                        v-if="ableToViewTask"
                        :to="{ name: 'EXCMTaskShow', params: {id: item.task['@id']} }"
                      >{{ item.task.idTaskType.title }}</router-link>
                      <span v-else>{{ item.task.idTaskType.title }}</span>
                    </td>
                    <td v-else></td>
                    <td v-if="item.idInvoice">
                      <router-link
                        v-if="ableToViewInvoice"
                        :to="{ name: 'EXSBInvoiceShow', params: {id: item.idInvoice['@id']} }"
                      >{{ item.idInvoice.number }}</router-link>
                      <span v-else>{{ item.idInvoice.number }}</span>
                    </td>
                    <td v-else></td>
                    <td>{{ item['number'] }}</td>
                    <td>{{ $moment(item['dateOfIssue']).format('YYYY-MM-DD') }}</td>
                    <td>
                      <router-link
                        v-if="ableToViewDocuments"
                        tag="button"
                        :to="{name: 'EXSBDocumentShow', params: { id: item['@id'] }}"
                        class="btn btn-link fa fa-search fa-lg" />
                      <span v-else></span>
                    </td>
                  </tr>
                </table>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import getId from '@/utils/getIdFromLink'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles.js'
import Loader from '@/components/Dashboard/Layout/Loader'
import ApiService from '@/utils/ApiService'

export default {
  computed: {
    ableToViewTask () {
      return checkPermission('tasks', 'EXCMTaskShow')
    },

    ableToViewInvoice () {
      return checkPermission('finances', 'EXSBInvoiceShow')
    },

    ableToViewDocuments () {
      return checkPermission('warehouses', 'EXSBDocumentList')
    },

    ...mapGetters({
      deleteError: 'exsbwarehouse/del/error',
      error: 'exsbwarehouse/show/error',
      isLoading: 'exsbwarehouse/show/isLoading',
      item: 'exsbwarehouse/show/retrieved'
    })
  },
  components: {
    Loader
  },

  beforeDestroy () {
    this.reset()
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBWarehouseShow')
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  data () {
    return {
      itemsStates: [],
      documents: []
    }
  },

  watch: {
    item: function (newItem) {
      if (newItem) {
        this.getItemsStates(this.getIdLink(newItem['@id']))
        this.channelBusinessItemsStates = this.$store.state.Pusher.subscribe('api/e_x_s_b_warehouse_items')
        this.channelBusinessItemsStates.bind('e_x_s_b_warehouse_items', data => {
          this.getItemsStates(this.getIdLink(newItem['@id']))
        })
        this.getWarehouseDocuments(this.getIdLink(newItem['@id']))
        this.channelBusinessDocuments = this.$store.state.Pusher.subscribe('api/e_x_s_b_documents')
        this.channelBusinessDocuments.bind('e_x_s_b_warehouse_warehouses', data => {
          this.getWarehouseDocuments(this.getIdLink(newItem['@id']))
        })
      }
    }
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_s_b_warehouse_items')
    this.$store.state.Pusher.unsubscribe('e_x_s_b_documents')
  },

  methods: {
    ...mapActions({
      del: 'exsbwarehouse/del/del',
      reset: 'exsbwarehouse/show/reset',
      retrieve: 'exsbwarehouse/show/retrieve'
    }),

    async getItemsStates (id) {
      const response = await new ApiService('e_x_s_b_warehouse_items?warehouse=' + id).getResults()
      this.itemsStates = response.items
    },
    async getWarehouseDocuments (id) {
      const response = await new ApiService('e_x_s_b_warehouses/' + id + '/documents').getResults()
      this.documents = response.items
    },

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'EXSBWarehouseList' }))
      }
    },

    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
